import accounting from 'accounting'

class ValidadorLotesProposta {

    constructor() {
        this.isMenorPreco = true
    }

    validar(propostaLotesItens, isMenorPreco, ehAmparoLei14133Art82) {
        this.isMenorPreco = isMenorPreco
        const lotes = this._getEstadoPreenchimentoLotes(propostaLotesItens, ehAmparoLei14133Art82)
        this._verificarItensSemPreenchimento(lotes, propostaLotesItens, ehAmparoLei14133Art82)
        return this._isFormularioValido(lotes)
    }

    _getEstadoPreenchimentoLotes(propostaLoteItens, ehAmparoLei14133Art82) {
        const lotes = {}
        propostaLoteItens.forEach(item => {
            if (lotes[item.loteId]) {
                this._somarItemNoLote(lotes, item)
            } else {
                this._iniciarContagemLote(lotes, item, ehAmparoLei14133Art82)
            }
        })
        return lotes
    }

    _somarItemNoLote(lotes, item) {
        const lote = lotes[item.loteId]
        lote.nbItens = lotes[item.loteId].nbItens + 1
        if (this._isItemPreenchido(item)) {
            lote.nbItensPreenchidos = lote.nbItensPreenchidos + 1
            if (this._isItemValido(item)) {
                lote.nbItensValidos = lote.nbItensValidos + 1
            }
        }
        lotes[item.loteId] = lote
    }

    _iniciarContagemLote(lotes, item, ehAmparoLei14133Art82) {
        const lote = {nbItens: 1, nbItensPreenchidos: 0, nbItensValidos: 0}
        if (this._isItemPreenchido(item)) {
            lote.nbItensPreenchidos = 1
            if (this._isItemValido(item, ehAmparoLei14133Art82)) {
                lote.nbItensValidos = 1
            }
        }
        lotes[item.loteId] = lote
    }

    _isItemPreenchido(item) {
        const isFormularioPreenchido = this._isFormularioLoteItemPreenchido(item)
        const isFichaAnexada = this._isFichaTecnicaAnexada(item)
        const isCatalogo = this._isCatalogoAnexado(item)
        return isFormularioPreenchido || isFichaAnexada || isCatalogo
    }

    _isFormularioLoteItemPreenchido(item) {
        return this._isPrecoPreenchido(item.preco)
    }

    _isPrecoPreenchido(preco) {
        if(this.isMenorPreco){
            return accounting.unformat(preco, ',') > 0
        } else {
            return preco != null
        }
    }

    _isQuantidadePreenchida(quantidadeProposta, quantidade) {
        return quantidadeProposta != null && quantidadeProposta !== '' && quantidadeProposta !== 0 && quantidadeProposta <= quantidade && quantidadeProposta % 1 === 0
    }

    _isArquivosAnexadosValidos(item) {
        return this._isFichaTecnicaValida(item) && this._isCatalogoValido(item)
    }

    _isItemValido(item, ehAmparoLei14133Art82) {
        const isFormularioValido = this._isFormularioLoteItemValido(item, ehAmparoLei14133Art82)
        return isFormularioValido && this._isArquivosAnexadosValidos(item)
    }

    _isFormularioLoteItemValido(item, ehAmparoLei14133Art82) {
        if(ehAmparoLei14133Art82){
            return this._isPrecoPreenchido(item.preco) && this._isQuantidadePreenchida(item.quantidadeProposta, item.quantidade)
        } else {
            return this._isPrecoPreenchido(item.preco)
        }
    }

    _isFichaTecnicaAnexada(item) {
        return item.fichaTecnica !== undefined && item.fichaTecnica !== null
    }

    _isCatalogoAnexado(item) {
        return item.catalogo !== undefined && item.catalogo !== null
    }

    _isFichaTecnicaValida(item) {
        if (item.incluirFicha && !this._isFichaTecnicaAnexada(item)) {
            return false
        }
        return true
    }

    _isCatalogoValido(item) {
        if (item.incluirCatalogo && !this._isCatalogoAnexado(item)) {
            return false
        }
        return true
    }

    _isFormularioValido(lotes) {
        let valido = true
        const that = this
        Object.keys(lotes).forEach(chaveLote => {
            const lote = lotes[chaveLote]
            if (that._isLoteComItensPreenchidos(lote) && that._lotePossuiItensInvalidos(lote)) {
                valido = false
            }
        })
        return valido
    }

    _isLoteComItensPreenchidos(lote) {
        return lote.nbItensPreenchidos > 0
    }

    _lotePossuiItensInvalidos(lote) {
        return lote.nbItens > lote.nbItensValidos
    }

    _marcarPropostaItemPreenchimentoInvalido(propostaItem) {
        propostaItem.preenchido = false
        propostaItem.invalido = true
        propostaItem.mensagem = this._montarMensagemValidacao(propostaItem)
    }

    _montarMensagemValidacao(propostaItem) {
        let mensagem = '<span>Informe os dados do item</span><ul>'
        if (!this._isPrecoPreenchido(propostaItem.preco)) {
            mensagem += '<li>Valor Unitário</li>'
        }
        if (!this._isQuantidadePreenchida(propostaItem.quantidadeProposta, propostaItem.quantidade)) {
            mensagem += '<li>Quantidade Fornecedor</li>'
        }
        if(propostaItem.quantidadeProposta > propostaItem.quantidade){
            mensagem = '<span>Quantidade da proposta ultrapassa a quantidade de itens licitados</span><ul>'
        }
        if (!this._isFichaTecnicaValida(propostaItem)) {
            mensagem += '<li>Ficha Técnica</li>'
        }
        if (!this._isCatalogoValido(propostaItem)) {
            mensagem += '<li>Catálogo</li>'
        }
        mensagem += '</ul>'
        return mensagem
    }

    _resetarValoresValidacao(propostaItem) {
        propostaItem.preenchido = true
        propostaItem.invalido = false
        propostaItem.mensagem = ''
    }

    _verificarItensSemPreenchimento(lotes, propostaLotesItens, ehAmparoLei14133Art82) {
        for (let i = 0; i < propostaLotesItens.length; i++) {
            const item = propostaLotesItens[i]
            const lote = lotes[item.loteId]
            if (this._isLoteComItensPreenchidos(lote) && !this._isItemValido(item, ehAmparoLei14133Art82)) {
                this._marcarPropostaItemPreenchimentoInvalido(item)
            } else if (this._isLoteComItensPreenchidos(lote) && this._isItemValido(item, ehAmparoLei14133Art82)) {
                this._resetarValoresValidacao(item)
            }
        }
    }
}

export default new ValidadorLotesProposta()
